"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dayjs_1 = __importDefault(require("dayjs"));
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const DefaultProps = {
    hasHours: false,
    style: styles_1.default.textTitle,
};
const DateComponent = ({ date, hasHours, style }) => {
    const formatString = hasHours ? 'DD MMM YYYY HH:mm' : 'DD MMM YYYY';
    return react_1.default.createElement(react_native_paper_1.Title, { style: style }, dayjs_1.default(date).format(formatString));
};
DateComponent.defaultProps = DefaultProps;
exports.default = DateComponent;
